<script setup lang="ts">
import BaseDialog from "@common-ui/components/BaseDialog.vue";

defineProps<{
	modelValue: boolean;
}>();

const emit = defineEmits<{
	"update:modelValue": [value: boolean];
	confirm: [];
}>();

const close = () => {
	emit("update:modelValue", false);
};

const confirm = () => {
	emit("confirm");
	close();
};
</script>

<template>
	<BaseDialog
		:model-value="modelValue"
		title="Download Information"
		size="sm"
		@update:model-value="emit('update:modelValue', $event)">
		<p>
			If you plan to download, edit and then upload this file,
			<strong>DO NOT</strong> add, change or delete columns or column headers.
		</p>
		<template #actions>
			<PrimaryBtn @click="confirm">OK</PrimaryBtn>
		</template>
	</BaseDialog>
</template>
